import React from 'react'
import PropTypes from 'prop-types'
import { FaAngleRight } from '@react-icons/all-files/fa/FaAngleRight'
import './SubmitButton.scss'

function SubmitButtonText({ buttonName }) {
  return (
    <>
      <span>{buttonName}</span>
      <FaAngleRight className="arrow-right" role="img" />
    </>
  )
}

function SubmitButton({ buttonName, loading }) {
  return (
    <div className="button-container">
      <button type="submit" className="SubmitButton" data-testid="submit-button" disabled={loading}>
        {loading ? <span>Loading</span> : <SubmitButtonText buttonName={buttonName} />}
      </button>
    </div>
  )
}

SubmitButton.defaultProps = {
  buttonName: '',
  loading: false
}

SubmitButton.propTypes = {
  buttonName: PropTypes.string,
  loading: PropTypes.bool
}

SubmitButtonText.defaultProps = {
  buttonName: ''
}

SubmitButtonText.propTypes = {
  buttonName: PropTypes.string
}

export default SubmitButton
